<template>
  <form-group v-bind="$attrs">
    <v-row>
      <v-col cols="9">
        <input-text
          id="input:subTituloAgrupador"
          v-model="payload.subTituloAgrupador"
          label="Sub-título agrupador"
          outlined
        />
      </v-col>
    </v-row>
    <produto-agrupamento
      :payload="payload"
      cols="9"
    />
    <v-row>
      <v-col cols="12">
        <termo-condicao-uso
          :loading="loading"
          :payload="payload"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-textarea
          id="input:txtInstrucaoResgate"
          v-model="payload.txtInstrucaoResgate"
          label="Texto instrução de resgate"
          outlined
          :loading="loading"
        />
      </v-col>
    </v-row>
    <upload-product-logo
      v-model="payload"
    />
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import TermoCondicaoUso from '../inputs/TermoCondicaoUso.vue';
import ProdutoAgrupamento from '../inputs/ProdutoAgrupamento.vue';
import UploadProductLogo from '../inputs/UploadProductLogo.vue';

export default {
  name: 'GiftCard',
  components: {
    TermoCondicaoUso,
    FormGroup,
    ProdutoAgrupamento,
    UploadProductLogo,
  },
  props: {
    payload: {
      type: Object,
      default() {
        return {
          id: '',
          idRegionalMarca: '',
          idAgrupamento: '',
          indBloqueado: '',
          txtObservacao: '',
          termoCondicaoUso: '',
          txtInstrucaoResgate: '',
          descricaoValor: '',
          tipoValorProduto: '',
          vlrProdutoServico: '',
          vlrVariavelMin: '',
          vlrVariavelMax: '',
          subTituloAgrupador: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>
